<div
  *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')&& (global.agencyCode=='SUPERADMIN')">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000') || (global.agencyCode!='SUPERADMIN')">
  <div class="row mb-2" *ngIf="!employeeTemplateBO.templateToOnboard && !ClientTemplateBO.templateToOnboard">
    <div class="col  pl-0">
      <div class="row">
        <div class="col-12">
          <h4 class="mb-0 font-header-1 mb-2"> Handbook </h4>
        </div>
      </div>
      <div class="card border-0 box-shadow mt-2">
        <div class="card-body">
          <div class="row d-flex align-items-center">

            <div class="col-lg-6 col-md-12 col-sm-12">
              <div class="col-11 d-inline-flex">

              </div>
            </div>
            <div *ngIf="this.global.OnboardingLoginType !='onboardLogin' && fp.handbookcreate"
              class="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-lg-end ">
              <button class="btn btn-sm ms-5" data-bs-toggle="modal" data-bs-target="#templateModal"
                (click)="clearName()">Create Handbook
              </button>

              <button class="btn btn-sm me-1 ms-3" (click)="refresh()">Refresh </button>

            </div>
          </div>
          <div class="row mt-3 pt-2">

            <div class="col-lg-12">

              <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-unlocked" role="tabpanel"
                  aria-labelledby="nav-unlocked-tab" [ngClass]="{
                      active: PrivatePaySelectedTab == 'Client',
                      show: PrivatePaySelectedTab == 'Client'
                    }">
                  <!-- UnLocked  ejs-grid -->
                  <div class="row mb-2 mt-1">

                    <div class="col-lg-12 pl-0">
                      <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowPaging]="true"
                        [allowMultiSorting]='true' [filterSettings]='filterOption' [allowSorting]="true"
                        [pageSettings]="pageSettings" (dataStateChange)='dataChangeAgreement($event)'
                        (actionBegin)="onActionAgreement($event)">


                        <e-columns>
                          <e-column headerText="Actions" textAlign="center" minWidth=40>
                            <ng-template #template let-data>
                              <button class="btn btn-sm" (click)="getViewHandBook(data.id)" data-bs-toggle="modal"
                                data-bs-target="#ViewHandbookmodal1" *ngIf="fp.handbookview"><i
                                  class="fa fa-eye"></i></button>&nbsp;
                              <button class="btn btn-sm" *ngIf="fp.handbookdownload" (click)="downloadFile(data)"><i
                                  class="fa fa-download"></i></button> &nbsp;
                              <button *ngIf="this.global.OnboardingLoginType !='onboardLogin'" data-bs-toggle="modal" data-bs-target="#templateModal" (click)="edit(data)"  class="btn btn-sm"  ><i
                                          class="fa fa-edit"></i></button>&nbsp; 
                              <button *ngIf="this.global.OnboardingLoginType !='onboardLogin'&& fp.handbookdelete"
                                class="btn btn-sm btn btn-delete-table " data-bs-toggle="modal"
                                data-bs-target="#modalHandbookdelete" (click)="deleteHandbook(data.id)"><i
                                  class="fa fa-trash"></i></button>
                            </ng-template>
                          </e-column>
                          <e-column field='handbookName' textAlign='left' type='string' headerText='HandBook Name'
                            minWidth=50>
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template></e-column>
                             <e-column field='type' textAlign='left' type='string' headerText='Type'
                            minWidth=50>
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template></e-column>
                          <e-column field='fileName' textAlign='left' type='string' headerText='File Name' minWidth=50>
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template></e-column>
                          <e-column field='createdTime' textAlign='left' type='date' headerText='Uploaded Date'
                            minWidth=50 [format]="formatDateOptions">
                          </e-column>
                        </e-columns>
                      </ejs-grid>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<span id="templateNameModal" data-bs-toggle="modal" data-bs-target="#templateModal"></span>
<div class="modal fade modalbackgrod" id="templateModal" tabindex="-1" aria-labelledby="templateModalLabel"
  aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog mt-5 pt-5" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="this.documentList.id == '00000000-0000-0000-0000-000000000000'" class="modal-title font-header" id="templateModalLabel"> Create Handbook</h5>
        <h5 *ngIf="this.documentList.id != '00000000-0000-0000-0000-000000000000'" class="modal-title font-header" id="templateModalLabel"> Update Handbook</h5>


        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="row mt-3">
          <div class="col-lg-4">
            <label>HandBook Name<sup class="super-script">&nbsp;*&nbsp;</sup> </label>
          </div>
          <div class="col-lg-7">
            <input type="text" class="form-control" [(ngModel)]="documentList.handbookName">
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-4">
            <label>Type<sup class="super-script">&nbsp;*&nbsp;</sup></label>
          </div>
          <div class="col-lg-7">
              <ng-select class="mt-1" [items]="typeList" [searchable]="true"
                      [(ngModel)]="documentList.type" [clearable]="true" bindLabel="name" bindValue="value"
                      ></ng-select>
          </div>
        </div>
        <div class="row mt-4" style="margin-bottom:5px">
          <div class="col-lg-4">
            <label>File<sup class="super-script">&nbsp;*&nbsp;</sup> </label>
          </div>
          <div class="col-lg-7">
            <div class="input-group mb-3">
              <input type="file" #edithandbookFile class="form-control" id="inputGroupFile02"
                (change)="onDOCFileChanged($event.target.files)" [(ngModel)]="documentList.filePath"
                accept="application/pdf">
            </div>

          </div>
          <div class="row">
            <div class="col-lg-4">
            </div>
            <div class="col-lg-7 ms-2">
              <label style="color: #386AAB;width: -webkit-fill-available">{{selectedDocumentFileName}}</label>
            </div>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" *ngIf="this.documentList.id == '00000000-0000-0000-0000-000000000000'" class="btn btn-sm" (click)="savehandbook(documentList)"
            [disabled]="isSaveorUpdateBoolean|| documentList.filePath == null || documentList.filePath == '' 
            || documentList.filePath==undefined || documentList.handbookName == undefined
            || documentList.handbookName == '' || documentList.handbookName == null || documentList.type == null || documentList.type == undefined">Create</button>
           <button type="button" *ngIf="this.documentList.id != '00000000-0000-0000-0000-000000000000'" class="btn btn-sm" (click)="savehandbook(documentList)"
            [disabled]="documentList.filePath == null || documentList.filePath == '' || documentList.filePath==undefined ||
             documentList.handbookName == undefined|| documentList.handbookName == '' || documentList.handbookName == null 
             || documentList.type == null || documentList.type == undefined">Update</button>
          <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>


<span id="openHandbookdelete" data-bs-toggle="modal" data-bs-target="#modalHandbookdelete"></span>
<div class="modal fade" id="modalHandbookdelete" data-bs-backdrop="static">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Delete </span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to Delete?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<span id="ViewHandbook22" data-bs-target="#ViewHandbookmodal1" data-bs-toggle="modal"></span>
<div class="modal fade" id="ViewHandbookmodal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header card-show">
        <div class="col-lg-3">
          <h5 class="modal-title font-header" id="exampleModalLabel">View Document<span>
            </span> </h5>
        </div>
        <div class="col-lg-7 text-end">
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

      </div>
      <div class="modal-body" *ngIf="pdfsrc!=null && pdfsrc!=undefined && pdfsrc!=''">
        <iframe [src]="pdfsrc" width="100%" height="600px"></iframe>

      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>